import {decomposeColor} from "@mui/system/colorManipulator";

export const isIOS = () => {
    // `navigator` only exists in the browser. Since SOSHDL-1802 the donation form (and its
    // payment-method filtering in F007ModularDonationForm/utils/formOptions.ts) is rendered
    // server-side, where accessing navigator throws and 500s the whole page. Treat the
    // server as "not iOS"; the client corrects it after hydration.
    if (typeof navigator === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            return false;
        } else {
            return ua.indexOf('firefox') <= -1;
        }
    } else {
        return false;
    }
}

export const getFocusBackgroundColor = (theme: any) => {
    const opacity = 0.15;
    const decomposedPrimaryColor = decomposeColor(theme.palette.primary.main);
    return decomposedPrimaryColor.type === 'rgb'
        ? `rgba(${decomposedPrimaryColor.values.join(', ')}, ${opacity})`
        : theme.palette.primary.main;
}